import { render, staticRenderFns } from "./versionList.vue?vue&type=template&id=18f48762&scoped=true&"
import script from "./versionList.vue?vue&type=script&lang=js&"
export * from "./versionList.vue?vue&type=script&lang=js&"
import style0 from "./versionList.vue?vue&type=style&index=0&id=18f48762&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f48762",
  null
  
)

export default component.exports